import { RadioGroup } from '@blueprintjs/core';
import styled from 'styled-components';
export const FARadioGroup = styled(RadioGroup) `
  span.bp3-control-indicator {
    background-color: white !important;
    box-shadow: unset !important;
    border: 1px solid var(--main-grey-2);
    display: inline-flex;
    height: 1.1em;
  }
  input:checked ~ span.bp3-control-indicator {
    border: 1px solid var(--main-green-1);
    ::before {
      align-self: center;
      background-image: radial-gradient(
        var(--main-green-1),
        var(--main-green-1) 0.3em,
        transparent 50%
      ) !important;
      height: 0.9em !important;
    }
  }
`;
//# sourceMappingURL=FARadio.js.map